import { createFileRoute } from "@tanstack/react-router";

import { KlaviyoFormPage } from "~/pages/connection-new/klaviyo-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/klaviyo",
)({
  component: KlaviyoFormPage,
});
